import React, { useState, useEffect } from 'react';
import NavBar from '../../../components/NavBar';
import Footer from '../../../components/Footer';
import Loading from '../../../components/Loading';
import { PiNotePencilBold } from 'react-icons/pi';
import { motion } from 'framer-motion';
import { TbTrash } from 'react-icons/tb';
import { FaCheck } from 'react-icons/fa6';

import { BsX } from 'react-icons/bs';
import { BsSortAlphaDown } from 'react-icons/bs';
import { RiPencilFill } from 'react-icons/ri';

import { IoSearch } from 'react-icons/io5';
import {
	requestDetailsCnes,
	requestNewUnits,
	requestUpdatePerfil,
	requestDeletePerfil,
} from '../../../services/requests';

import Cookies from 'js-cookie';

const Permissionador = () => {
	const [profissionais, setProfissionais] = useState([]);
	const [windowAlert, setWindowAlert] = useState(false);
	const [permissions, setPermissions] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [unitSelector, setUnitSelector] = useState(false);
	const [selectedCnes, setSelectedCnes] = useState('');
	const [filteredList, setFilteredList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [listUnits, setListUnits] = useState([]);
	const [userForm, setUserForm] = useState({
		perfil: {
			username: '',
			email: '',
			nome: '',
		},
		unidade: '',
		groups: [],
		ativo: true,
	});
	const [currentPopup, setCurrentPopup] = useState('');
	const [page, setPage] = useState('Editar Permissões');
	const [searchTriggered, setSearchTriggered] = useState(false); // Novo estado para controlar a pesquisa

	const handleRequest = async (id) => {
		setLoading(true);
		const user = JSON.parse(Cookies.get('user'));
		const removedUsers =
			JSON.parse(localStorage.getItem('removedUsers')) || [];

		try {
			let unidade_id = id;
			if (user.cnes) {
				unidade_id = user.cnes.replace(/-/g, '');
			}
			const profs = await requestDetailsCnes(user.token, unidade_id);

			if (!profs.error && Array.isArray(profs)) {
				let filter = profs.flatMap((item) => {
					// Processa cada unidade do perfil_unidades
					return item.perfil_unidades.map((unidade) => ({
						username: item.username,
						nome: item.nome,
						email: item.email,
						ativo: unidade.ativo,
						unidade_id: unidade.unidade_id,
						nome_unidade: unidade.nome_unidade,
						cnes: unidade.cnes,
						groups: unidade.groups,
					}));
				});

				// Remove usuários que estão na lista de removidos
				filter = filter.filter(
					(user) =>
						!removedUsers.includes(user.username) &&
						user.unidade_id === unidade_id
				);

				setProfissionais(filter);
				setFilteredList(filter); // Atualiza a lista filtrada
			} else {
				console.error(
					'Erro ao buscar profissionais:',
					profs.error || 'Resposta inválida'
				);
			}
		} catch (error) {
			console.error('Erro ao chamar a API:', error);
		}
		setLoading(false);
	};

	const handleSetPermissions = async (user, input, checked) => {
		const cookie = JSON.parse(Cookies.get('user'));
		let updatedGroups = [...user.groups];

		if (checked) {
			// Adiciona o grupo se estiver marcado
			if (!updatedGroups.includes(input)) {
				updatedGroups.push(input);
			}
		} else {
			// Remove o grupo se estiver desmarcado
			updatedGroups = updatedGroups.filter((group) => group !== input);
		}

		try {
			// Obter os detalhes do usuário para buscar o perfil_id
			const userDetails = await requestDetailsCnes(cookie.token);
			const userData = userDetails.find(
				(u) => u.username === user.username
			);

			if (
				!userData ||
				!userData.perfil_unidades ||
				userData.perfil_unidades.length === 0
			) {
				console.error(
					"Erro: 'perfil_id' está ausente ou inválido:",
					userData
				);
				return;
			}

			const perfilId = userData.perfil_unidades[0]?.id;

			if (!perfilId) {
				console.error("Erro: 'perfil_id' não encontrado.");
				return;
			}

			// Atualizar permissões com perfil_id
			const response = await requestUpdatePerfil(
				cookie.token,
				user.username,
				{
					perfil_id: perfilId,
					groups: updatedGroups,
					ativo: user.ativo,
				}
			);

			if (!response.error) {
				

				// Atualiza o estado local para refletir as mudanças
				setProfissionais((prevProfissionais) =>
					prevProfissionais.map((profissional) =>
						profissional.username === user.username
							? { ...profissional, groups: updatedGroups }
							: profissional
					)
				);
				setFilteredList((prevFilteredList) =>
					prevFilteredList.map((profissional) =>
						profissional.username === user.username
							? { ...profissional, groups: updatedGroups }
							: profissional
					)
				);
			} else {
				console.error('Erro ao atualizar permissões:', response.error);
			}
		} catch (error) {
			console.error('Erro inesperado ao atualizar permissões:', error);
		}
	};

	const handleFilter = async (lista, input) => {
		let argo = lista.filter((item) => {
			// Verifique se as propriedades existem antes de acessá-las
			return (
				item.username?.toLowerCase().includes(input.toLowerCase()) ||
				item.email?.toLowerCase().includes(input.toLowerCase()) ||
				item.nome?.toLowerCase().includes(input.toLowerCase()) ||
				item.unidade?.toLowerCase().includes(input.toLowerCase())
			);
		});
		setFilteredList(argo);
		setSearchTriggered(true); // Marca que a pesquisa foi realizada
	};

	const handleAprove = async (user) => {
		setLoading(true);
		const cookie = JSON.parse(Cookies.get('user'));

		try {
			// Obter os detalhes do usuário pela rota
			const userDetails = await requestDetailsCnes(cookie.token);
			const userData = userDetails.find(
				(u) => u.username === user.username
			);

			if (
				!userData ||
				!userData.perfil_unidades ||
				userData.perfil_unidades.length === 0
			) {
				console.error(
					"Erro: 'perfil_id' está ausente ou inválido:",
					userData
				);
				setLoading(false);
				return;
			}

			// Obter o ID correto do perfil de unidade
			const perfilId = userData.perfil_unidades[0]?.id;

			if (!perfilId) {
				console.error("Erro: 'perfil_id' não encontrado.");
				setLoading(false);
				return;
			}

			// Atualizar o perfil do usuário para ativo
			let response = await requestUpdatePerfil(
				cookie.token,
				user.username,
				{
					perfil_id: perfilId,
					groups: [...user.groups],
					ativo: true,
				}
			);

			if (!response.error) {
			
				handleRequest(); // Atualiza a lista de usuários
			} else {
				console.error('Erro ao reativar perfil:', response.error);
			}
		} catch (error) {
			console.error('Erro inesperado ao aprovar perfil:', error);
		}

		setLoading(false);
	};

	// Função para abrir o popup de exclusão
	const handleDelete = async (user) => {
		setLoading(true); // Mostra o estado de carregamento
		const cookie = JSON.parse(Cookies.get('user'));

		try {
			// Obter os detalhes do usuário pela rota
			const userDetails = await requestDetailsCnes(cookie.token);
			const userData = userDetails.find(
				(u) => u.username === user.username
			);

			if (
				!userData ||
				!userData.perfil_unidades ||
				userData.perfil_unidades.length === 0
			) {
				console.error(
					"Erro: 'perfil_id' está ausente ou inválido:",
					userData
				);
				setLoading(false);
				return;
			}

			// Obter o ID correto do perfil de unidade
			const perfilId = userData.perfil_unidades[0]?.id;

			if (!perfilId) {
				console.error("Erro: 'perfil_id' não encontrado.");
				setLoading(false);
				return;
			}

			// Log para depuração
		

			// Chama a API para desativar o perfil
			let response = await requestDeletePerfil(
				cookie.token,
				user.username,
				perfilId // Enviar o perfil_id na requisição
			);

			if (!response.error) {
			
				handleRequest(); // Atualiza a lista de usuários
			} else {
				console.error('Erro ao desativar perfil:', response.error);
			}
		} catch (error) {
			console.error('Erro inesperado ao desativar perfil:', error);
		}

		setTimeout(() => {
			setLoading(false); // Remove o estado de carregamento
			setCurrentPopup(null); // Fecha o popup após a ação
		}, 1000);
	};

	// Função para abrir o popup de permissões
	const handlePermissions = (user) => {
		// Fecha o popup se já estiver aberto, caso contrário, abre
		if (
			currentPopup?.type === 'permissions' &&
			currentPopup?.userId === user.username
		) {
			setCurrentPopup(null);
		} else {
			setCurrentPopup({ type: 'permissions', userId: user.username });
		}
	};

	// Função para confirmar a exclusão
	const confirmDelete = async (user) => {
		setLoading(true);
		const cookie = JSON.parse(Cookies.get('user'));

		try {
			// Obter os detalhes do usuário pela rota
			const userDetails = await requestDetailsCnes(cookie.token);
			const userData = userDetails.find(
				(u) => u.username === user.username
			);

			if (
				!userData ||
				!userData.perfil_unidades ||
				userData.perfil_unidades.length === 0
			) {
				console.error(
					"Erro: 'perfil_id' está ausente ou inválido:",
					userData
				);
				setLoading(false);
				return;
			}

			// Obter o ID correto do perfil de unidade
			const perfilId = userData.perfil_unidades[0]?.id;

			

			let response = await requestDeletePerfil(
				cookie.token,
				user.username,
				perfilId // Enviar o perfil_id na requisição
			);

			if (!response.error) {
			
				handleRequest();
			} else {
				console.error('Erro ao desativar perfil:', response.error);
			}
		} catch (error) {
			console.error('Erro inesperado ao desativar perfil:', error);
		}

		setTimeout(() => {
			setLoading(false);
			setCurrentPopup(null); // Fecha o popup após a ação
		}, 1000);
	};

	const handleRemoveFromList = (username) => {
		setProfissionais((prevProfissionais) =>
			prevProfissionais.filter((user) => user.username !== username)
		);
	};

	const handleRemoveWithConfirmation = (username) => {
		if (
			currentPopup?.type === 'delete' &&
			currentPopup?.userId === username
		) {
			// Remove o usuário da lista
			setProfissionais((prevProfissionais) =>
				prevProfissionais.filter((user) => user.username !== username)
			);
			setFilteredList((prevFilteredList) =>
				prevFilteredList.filter((user) => user.username !== username)
			);

			// Atualiza o estado local para garantir que o usuário não reapareça após a atualização
			localStorage.setItem(
				'removedUsers',
				JSON.stringify([
					...(JSON.parse(localStorage.getItem('removedUsers')) || []),
					username,
				])
			);

			setCurrentPopup(null); // Fecha o popup após a remoção
		} else {
			setCurrentPopup({ type: 'delete', userId: username }); // Abre o popup de confirmação
		}
	};

	const confirmRemoveFromList = (username) => {
		setProfissionais((prevProfissionais) =>
			prevProfissionais.filter((user) => user.username !== username)
		);
		setCurrentPopup(null); // Fecha o popup após a remoção
	};

	const handleApproveWithConfirmation = (username) => {
		if (
			currentPopup?.type === 'approve' &&
			currentPopup?.userId === username
		) {
			setCurrentPopup(null); // Fecha o popup se já estiver aberto
		} else {
			setCurrentPopup({ type: 'approve', userId: username }); // Abre o popup de confirmação
		}
	};

	const ListUnits = async () => {
		const result = await requestNewUnits();
		if (!result.error) {
			setListUnits(result);
		} else {
			console.log(result.error);
		}
	};

	const [paginaAtual, setPaginaAtual] = useState(1);

	const itensPorPagina = window.innerWidth <= 768 ? 3 : 8; // 3 itens para mobile, 20 para desktop
	const totalPaginas = Math.ceil(filteredList.length / itensPorPagina);
	const filteredListPaginated = filteredList.slice(
		(paginaAtual - 1) * itensPorPagina,
		paginaAtual * itensPorPagina
	);

	useEffect(() => {
		ListUnits();
		if (Cookies.get('user')) {
			const user = JSON.parse(Cookies.get('user'));
			const cargo = user?.cargo || [];
			const groups = user?.groups || [];
			const permissao = user?.permissao || [];

			if (cargo.includes('gestor') || cargo.includes('desenvolvedor')) {
				if (cargo.includes('desenvolvedor')) {
					setUnitSelector(true);
					setWindowAlert(false);
				} else if (
					groups.includes('gestor') ||
					cargo.includes('gestor') ||
					permissao.includes('Gestores')
				) {
					handleRequest();
					setWindowAlert(false);
				}
			}
		} else {
			setWindowAlert(true);
		}
	}, []);

	const handleCheckboxChange = (profissionalId, permissao) => {
		setProfissionais((prevProfissionais) =>
			prevProfissionais.map((profissional) => {
				if (profissional.id === profissionalId) {
					const possuiPermissao =
						profissional.permissao.includes(permissao);
					const novasPermissoes = possuiPermissao
						? profissional.permissao
								.split('/')
								.filter((p) => p !== permissao)
								.join('/')
						: `${profissional.permissao}/${permissao}`.replace(
								/^\/|\/$/g,
								''
						  );
					/* console.log({
						...profissional,
						permissao: novasPermissoes,
					}); */
					return { ...profissional, permissao: novasPermissoes };
				}
				return profissional;
			})
		);
	};

	const handleSubmit = () => {
		const permissoesAtualizadas = profissionais.map((p) => ({
			id: p.id,
			permissao: p.permissao,
		}));
		const token = JSON.parse(Cookies.get('user')).token;
		const userConfirmed = window.confirm(
			'Tem certeza que deseja continuar com as alterações?'
		);

		if (userConfirmed) {
			/* 	console.log({ token, body: permissoesAtualizadas }); */
			/* updatePermissions({ token, body: permissoesAtualizadas }); */
			/* window.location.reload(); */
		} else {
			let aux = [];
			let result = permissoesAtualizadas.forEach((item) => {
				if (item.permissao === 'notificacoes/escala') {
					let curr = item;
					curr.permissao = 'escala/notificacoes';
					aux.push(curr);
				} else {
					aux.push(result);
				}
			});
			/* console.log(aux);
			console.log(permissoesAtualizadas);
			console.log('Usuário cancelou a ação.'); */
		}
	};

	const isMobile = window.innerWidth <= 768; // Verifica se é mobile
	const limitedList = filteredList.length > 0 ? filteredList : profissionais; // Remove limites de exibição

	return (
		<div className='flex flex-col min-h-screen font-inter'>
			<NavBar />

			{windowAlert ? (
				<section className='bg-[#004A80] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] mt-[130px] mx-auto my-auto'>
					<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
						<div className='mx-auto max-w-screen-sm text-center'>
							<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
								401
							</h1>
							<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
								Acesso Negado
							</p>
							<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
								Você não possui permissão para acessar este
								campo. Entre em contato com o administrador(a)
								da sua unidade para solicitação de acesso.
							</p>
							<a
								href='/login'
								className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4'>
								Volte para a Tela de Login
							</a>
						</div>
					</div>
				</section>
			) : (
				<div className='flex-grow mt-[80px] mb-[10%] min-h-screen '>
					<div className='h-[74px]'>
						<h2 className='text-[32px] font-inter px-[32px] py-[36px] font-bold bg-[#F0F4F8] text-[#004A80] text-center'>
							Editor de Permissões
						</h2>
						<div className='flex flex-col gap-3 flex-grow justify-center bg-white mt-6 mx-auto w-[90%] sm:w-[95%] max-w-[1136px]'>
							{/* SEARCHBAR */}
							<div className='max-h-[100px] sm:flex-row flex-col sm:gap-0 gap-3 w-full flex justify-end'>
								{unitSelector ? (
									<select
										onChange={(event) => {
											handleRequest(event.target.value);
										}}
										className='p-1 border-[2px] border-[#757575] w-[200px] overflow-x-hidden rounded-lg'>
										<option value=''>
											Selecione a unidade
										</option>

										{listUnits.map((unit, index) => (
											<option
												key={index + 'pork'}
												value={unit.id}>
												{unit.nome}
											</option>
										))}
									</select>
								) : null}
								<div className='max-h-[100px] w-full flex sm:flex-row flex-col sm:justify-end gap-0'>
									<div className='flex w-full sm:w-auto'>
										<input
											type='text'
											placeholder='Pesquisar'
											onChange={(event) =>
												setSearchValue(
													event.target.value
												)
											}
											className='w-full sm:w-[280px] text-[14px] border-[#E3E3E3] border-[1px] rounded-l-md sm:rounded-r-none px-2 py-1 placeholder:text-[#E3E3E3]'
										/>
										<button
											onClick={() =>
												handleFilter(
													profissionais,
													searchValue
												)
											}
											className='w-[48px] h-[40px] flex justify-center items-center text-[#004A80] hover:text-white hover:bg-[#004A80] border-[1px] border-l-0 border-[#E3E3E3] rounded-r-md sm:rounded-l-none transition-all duration-200'>
											<IoSearch className='w-[20px] h-[20px]' />
										</button>
									</div>
								</div>
							</div>

							{/* BLOCO DA TABELA */}
							<div className='text-[14px] border-[#E3E3E3]  rounded-md  py-1 rounded-r-none placeholder:text-[#E3E3E3]'>
								{/* NAVBAR */}
								<div className='flex w-full  border-b-[2px] border-[E3E3E3]'>
									<button
										onClick={() =>
											setPage('Editar Permissões')
										}
										className={`flex relative py-1 px-3  text-[#757575] ${
											page === 'Editar Permissões'
												? 'border-[2px] border-b-0 border-[#E3E3E3]'
												: ''
										}`}>
										Editar Permissões
										{page === 'Editar Permissões' ? (
											<div className='absolute bg-[white] left-0 bottom-[-3px] w-full h-[3px] '></div>
										) : null}
										{/* {profissionais.filter(
											(item) => item.ativo === true
										).length > 0 ? (
											<div className='text-white ml-1 flex items-center justify-center bg-[#00C0F3] font-medium w-[14px] h-[14px] text-[10px] rounded-[666px] my-auto p-[2px]'>
												{
													profissionais.filter(
														(item) =>
															item.ativo === true
													).length
												}
											</div>
										) : null} */}
									</button>
									<button
										onClick={() =>
											setPage('Aprovar usuário')
										}
										className={`relative py-1 px-3 flex  text-[#757575] ${
											page === 'Aprovar usuário'
												? 'border-[2px] border-b-0 border-[#E3E3E3]'
												: ''
										}`}>
										Aprovar usuário
										{page === 'Aprovar usuário' ? (
											<div className='absolute bg-[white] left-0 bottom-[-3px] w-full h-[3px] '></div>
										) : null}
										{profissionais.filter(
											(item) => item.ativo === false
										).length > 0 ? (
											<div className='text-white ml-1 flex items-center justify-center bg-[#00C0F3] font-medium w-[14px] h-[14px] text-[10px] rounded-[666px] my-auto p-[2px]'>
												{
													profissionais.filter(
														(item) => !item.ativo
													).length
												}
											</div>
										) : null}
									</button>
								</div>
								{/* NAV TABLE */}
								{page === 'Editar Permissões' ? (
									<div>
										<div className='w-full border-b-[1px] pb-[17px] border-[#E3E3E3] flex justify-between my-5 px-4 text-[#757575] font-semibold'>
											<p className='w-[300px] flex items-center gap-2'>
												<BsSortAlphaDown className='text-[#757575]' />
												<span className='block md:hidden'>
													Usuários
												</span>
												<span className='hidden md:block'>
													Nome
												</span>
											</p>

											{/* E-mail (esconde em mobile) */}
											<p className='w-[300px] text-center hidden md:block'>
												E-mail
											</p>

											{/* CPF (esconde em mobile) */}
											<p className='w-[300px] text-center hidden md:block'>
												CPF
											</p>

											{/* Ações */}
											<p className='w-[80px] text-center'>
												Ações
											</p>
										</div>
										{/* LISTA DE USUARIOS */}
										{loading ? (
											<Loading />
										) : (
											<>
												{/* Mobile Layout */}
												<div className='sm:hidden'>
													{/* Mensagem para mobile */}
													{filteredList.length ===
														0 && (
														<div className='sm:hidden my-10 text-[#9c9c9c] ml-6 font-semibold text-center font-inter text-[14px]'>
															Nenhum usuário
															encontrado...
														</div>
													)}
												</div>
												<div className='sm:hidden'>
													{filteredListPaginated
														.filter(
															(user) => user.ativo
														) // Primeiro, filtra os inativos
														.map((user, index) => (
															<div
																key={
																	index +
																	'pos'
																}
																className='w-full flex flex-col justify-between my-[16px] px-4 text-[#757575] font-normal border-b-[1px] border-[#E3E3E3] pb-4'>
																<div className='flex flex-row justify-between items-center mt-4'>
																	<div>
																		<p
																			className>
																			<strong>
																				Nome:
																			</strong>{' '}
																			{
																				user.nome
																			}
																		</p>
																		<p className='text-sm text-gray-500'>
																			<strong>
																				Email:
																			</strong>{' '}
																			{
																				user.email
																			}
																		</p>
																		<p className='text-sm text-gray-500'>
																			<strong>
																				CPF:
																			</strong>{' '}
																			{
																				user.username
																			}
																		</p>
																	</div>
																	<div className='flex flex-col gap-2 justify-center items-center'>
																		<button
																			onClick={() =>
																				handlePermissions(
																					user
																				)
																			}
																			className='w-[80px] h-[30px] text-white bg-[#004A80] hover:bg-[#003366] rounded-md text-sm'>
																			{currentPopup?.type ===
																				'permissions' &&
																			currentPopup?.userId ===
																				user.username
																				? 'Salvar'
																				: 'Editar'}
																		</button>

																		<button
																			onClick={() => {
																				if (
																					currentPopup?.type ===
																						'delete' &&
																					currentPopup?.userId ===
																						user.username
																				) {
																					setCurrentPopup(
																						null
																					); // Fecha o popup se já estiver aberto
																				} else {
																					setCurrentPopup(
																						{
																							type: 'delete',
																							userId: user.username,
																						}
																					); // Abre o popup de confirmação
																				}
																			}}
																			className='w-[80px] h-[30px] text-white bg-[#B74644] hover:bg-[#A33E3C] rounded-md text-sm'>
																			Desativar
																		</button>
																	</div>
																</div>
																{currentPopup?.type ===
																	'permissions' &&
																	currentPopup?.userId ===
																		user.username && (
																		<div
																			className={`overflow-hidden transition-all duration-300 ease-in-out ${
																				currentPopup?.type ===
																				'permissions'
																					? 'h-[155px] border-[1px]'
																					: 'h-[1px] border-[0px]'
																			}`}>
																			<div
																				className={`${
																					currentPopup?.type ===
																					'permissions'
																						? 'bg-[#004A80]'
																						: 'bg-[#e9e9e9]'
																				}  p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500 `}>
																				Permissões
																			</div>

																			<div
																				className={`flex px-6 py-3 gap-10 my-2 transition-all duration-500 `}>
																				<div className='text-[14px] font-medium text-[#757575]'>
																					Notificação
																					de
																					Incidentes
																					<label className='mt-2 font-normal flex border-[#757575] justify-between'>
																						<p>
																							Classificação
																						</p>
																						<input
																							type='checkbox'
																							name='notificacao'
																							value='Classificadores'
																							className='peer sr-only'
																							defaultChecked={user.groups.includes(
																								'Classificadores'
																							)}
																							onChange={(
																								event
																							) =>
																								handleSetPermissions(
																									user,
																									event
																										.target
																										.value,
																									event
																										.target
																										.checked
																								)
																							}
																						/>
																						<span className='w-[13px] h-[13px] border-[1px] my-auto rounded-[2.5px] border-gray-500 bg-white flex items-center justify-center peer-checked:bg-blue-500 peer-checked:border-blue-500 peer-checked:hover:border-blue-600 peer-checked:hover:bg-blue-600 transition text-white'>
																							<FaCheck className='scale-[95%]' />
																						</span>
																					</label>
																					<label className='font-normal flex border-[#757575] justify-between'>
																						<p>
																							Investigação
																						</p>
																						<input
																							type='checkbox'
																							name='notificacao'
																							value='Investigadores'
																							className='peer sr-only'
																							checked={permissions.includes(
																								'Investigadores'
																							)} // Sincroniza com o estado atualizado
																							onChange={async (
																								event
																							) => {
																								const isChecked =
																									event
																										.target
																										.checked;
																								try {
																									await handleSetPermissions(
																										user,
																										event
																											.target
																											.value,
																										isChecked
																									);
																									setPermissions(
																										(
																											prev
																										) =>
																											isChecked
																												? [
																														...prev,
																														event
																															.target
																															.value,
																												  ]
																												: prev.filter(
																														(
																															perm
																														) =>
																															perm !==
																															event
																																.target
																																.value
																												  )
																									);
																								} catch (error) {
																									console.error(
																										'Erro ao atualizar permissão:',
																										error
																									);
																								}
																							}}
																						/>
																						<span className='w-[13px] h-[13px] border-[1px] my-auto rounded-[2.5px] border-gray-500 bg-white flex items-center justify-center peer-checked:bg-blue-500 peer-checked:border-blue-500 peer-checked:hover:border-blue-600 peer-checked:hover:bg-blue-600 transition text-white'>
																							<FaCheck className='scale-[95%]' />
																						</span>
																					</label>
																				</div>
																				<div className='h-[70px] my-auto w-[2px] bg-[#E3E3E3]'></div>
																			</div>
																		</div>
																	)}
																{currentPopup?.type ===
																	'delete' &&
																	currentPopup?.userId ===
																		user.username && (
																		<div
																			className={`overflow-hidden transition-all duration-300 ease-in-out ${
																				currentPopup?.type ===
																				'delete'
																					? 'h-auto border-[1px]'
																					: 'h-[1px] border-[0px]'
																			}`}>
																			<div
																				className={`${
																					currentPopup?.type ===
																					'delete'
																						? 'bg-[#B74644]'
																						: 'bg-[#e9e9e9]'
																				} p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500`}>
																				Confirmar
																				Desativar
																			</div>

																			<div className='flex px-6 py-3 gap-10 my-2 transition-all duration-500'>
																				<div className='text-[14px] font-medium text-[#757575]'>
																					<p className='text-[14px] font-medium text-[#757575]'>
																						Essa
																						ação
																						irá
																						desativar
																						o
																						usuário{' '}
																						<strong>
																							{
																								user.nome
																							}
																						</strong>

																						.
																						Confirma?
																					</p>
																					<div className='flex gap-4 mt-4'>
																						<button
																							onClick={async () => {
																								await handleDelete(
																									user
																								); // Chama a função para desativar o usuário
																								setCurrentPopup(
																									null
																								); // Fecha o popup
																							}}
																							className='bg-[#B74644] text-white px-4 py-2 rounded-md hover:bg-[#A33E3C] transition-all'>
																							Confirmar
																						</button>
																						<button
																							onClick={() =>
																								setCurrentPopup(
																									null
																								)
																							} // Cancela a desativação
																							className='bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-all'>
																							Cancelar
																						</button>
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
															</div>
														))}

													{/* Paginação */}
													<div className='flex justify-center items-center gap-2 mt-6 flex-wrap'>
														<button
															onClick={() =>
																setPaginaAtual(
																	(p) =>
																		Math.max(
																			1,
																			p -
																				1
																		)
																)
															}
															disabled={
																paginaAtual ===
																1
															}
															className={`px-3 py-1 rounded bg-gray-200 hover:text-white transition-all ${
																paginaAtual ===
																1
																	? 'opacity-50 cursor-not-allowed'
																	: ''
															}`}>
															Anterior
														</button>

														{Array.from(
															{
																length: totalPaginas,
															},
															(_, i) => i + 1
														).map((pagina) => (
															<button
																key={pagina}
																onClick={() =>
																	setPaginaAtual(
																		pagina
																	)
																}
																className={`px-3 py-1 rounded border ${
																	paginaAtual ===
																	pagina
																		? 'bg-[#004A80] text-white'
																		: 'bg-white text-gray-700 hover:bg-[#004A80] hover:text-white'
																}`}>
																{pagina}
															</button>
														))}

														<button
															onClick={() =>
																setPaginaAtual(
																	(p) =>
																		Math.min(
																			totalPaginas,
																			p +
																				1
																		)
																)
															}
															disabled={
																paginaAtual ===
																totalPaginas
															}
															className={`px-3 py-1 rounded bg-gray-200 hover:text-white transition ${
																paginaAtual ===
																totalPaginas
																	? 'opacity-50 cursor-not-allowed'
																	: ''
															}`}>
															Próxima
														</button>
													</div>
												</div>

												{/* Desktop Layout */}
												<div className='hidden sm:block'>
													{filteredList.length ===
													0 ? (
														<div className='my-10 text-[#9c9c9c] ml-6 font-semibold font-inter text-[16px]'>
															Nenhum usuário
															encontrado...
														</div>
													) : (
														<div>
															{filteredListPaginated
																.filter(
																	(user) =>
																		user.ativo
																) // Primeiro, filtra os inativos
																.map(
																	(
																		user,
																		index
																	) => (
																		<div
																			key={
																				index +
																				'pos'
																			}>
																			<div className='w-full flex pt-0 border-[#E3E3E3] justify-between my-[16px] px-4 text-[#757575] font-normal'>
																				<p className='flex sm:w-[300px] w-[80px] '>
																					{' '}
																					{
																						user.nome
																					}
																				</p>
																				<p className='sm:w-[300px]  w-[100px] overflow-x-scroll sm:overflow-x-auto text-center'>
																					{
																						user.email
																					}
																				</p>
																				<p className='sm:w-[300px]  w-[50px] overflow-x-scroll sm:overflow-x-auto text-center'>
																					{
																						user.username
																					}
																				</p>

																				<div className='flex sm:flex-row flex-col gap-2 sm:w-[80px] justify-center items-center overflow-hidden'>
																					{currentPopup?.type ===
																						'permissions' &&
																					currentPopup?.userId ===
																						user.username ? (
																						<button
																							onClick={() => {
																								handleSetPermissions(
																									user,
																									null,
																									null
																								);
																								setCurrentPopup(
																									null
																								);
																							}}
																							className='w-[25px] h-[25px] p-1 border-[1px] border-[#c4c4c4] bg-[#FFFFFF] text-[#32993E] rounded-md transition-transform duration-200 flex items-center justify-center hover:scale-105 hover:bg-[#32993E] hover:text-white'>
																							<FaCheck className='w-[16px] h-[16px]' />
																						</button>
																					) : (
																						<button
																							onClick={() =>
																								handlePermissions(
																									user
																								)
																							}
																							className='w-[25px] h-[25px] p-1 border-[1px] border-[#c4c4c4] rounded-md transition-transform duration-200 flex items-center justify-center hover:scale-105 hover:bg-[#004A80] hover:text-[#FFFFFF]'>
																							<RiPencilFill className='w-[16px] h-[16px]' />
																						</button>
																					)}
																					<button
																						onClick={() => {
																							if (
																								currentPopup?.type ===
																									'delete' &&
																								currentPopup?.userId ===
																									user.username
																							) {
																								setCurrentPopup(
																									null
																								); // Fecha o popup se já estiver aberto
																							} else {
																								setCurrentPopup(
																									{
																										type: 'delete',
																										userId: user.username,
																									}
																								); // Abre o popup de confirmação
																							}
																						}}
																						className='w-[25px] h-[25px] p-1 border-[1px] border-[#c4c4c4] rounded-md transition-all duration-200 flex items-center justify-center hover:bg-[#B74644] group'>
																						<TbTrash className='w-[14px] h-[14px] text-[#B74644] group-hover:text-white transition-all duration-200' />
																					</button>
																				</div>
																			</div>
																			{/* POPUP DE EDIÇÃO */}

																			<div
																				className={`transition-all overflow-hidden duration-300  ${
																					currentPopup?.type ===
																						'permissions' &&
																					currentPopup?.userId ===
																						user.username
																						? 'h-[180px] border-[1px]'
																						: 'h-0 border-[0px] '
																				}`}>
																				<div
																					className={`${
																						currentPopup?.type ===
																							'permissions' &&
																						currentPopup?.userId ===
																							user.username
																							? 'bg-[#004A80]'
																							: 'bg-[#e9e9e9]'
																					}  p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] overflow-hidden transition-all duration-500 `}>
																					Permissões
																				</div>
																				<div
																					className={`flex px-6 py-3 gap-10 my-2 transition-all duration-500 `}>
																					<div className='text-[14px] font-medium text-[#757575]'>
																						Notificação
																						de
																						Incidentes
																						<label className='mt-2 font-normal flex border-[#757575] justify-between'>
																							<p>
																								Classificação
																							</p>
																							<input
																								type='checkbox'
																								name='notificacao'
																								value='Classificadores'
																								className='peer sr-only'
																								defaultChecked={user.groups.includes(
																									'Classificadores'
																								)}
																								onChange={(
																									event
																								) =>
																									handleSetPermissions(
																										user,
																										event
																											.target
																											.value,
																										event
																											.target
																											.checked
																									)
																								}
																							/>
																							<span className='w-[13px] h-[13px] border-[1px] my-auto rounded-[2.5px] border-gray-500 bg-white flex items-center justify-center peer-checked:bg-blue-500 peer-checked:border-blue-500 peer-checked:hover:border-blue-600 peer-checked:hover:bg-blue-600 transition text-white'>
																								<FaCheck className='scale-[95%]' />
																							</span>
																						</label>
																						<label className='font-normal flex border-[#757575] justify-between'>
																							<p>
																								Investigação
																							</p>
																							<input
																								type='checkbox'
																								name='notificacao'
																								value='Investigadores'
																								className='peer sr-only'
																								checked={permissions.includes(
																									'Investigadores'
																								)} // Sincroniza com o estado atualizado
																								onChange={async (
																									event
																								) => {
																									const isChecked =
																										event
																											.target
																											.checked;
																									try {
																										await handleSetPermissions(
																											user,
																											event
																												.target
																												.value,
																											isChecked
																										);
																										setPermissions(
																											(
																												prev
																											) =>
																												isChecked
																													? [
																															...prev,
																															event
																																.target
																																.value,
																													  ]
																													: prev.filter(
																															(
																																perm
																															) =>
																																perm !==
																																event
																																	.target
																																	.value
																													  )
																										);
																									} catch (error) {
																										console.error(
																											'Erro ao atualizar permissão:',
																											error
																										);
																									}
																								}}
																							/>
																							<span className='w-[13px] h-[13px] border-[1px] my-auto rounded-[2.5px] border-gray-500 bg-white flex items-center justify-center peer-checked:bg-blue-500 peer-checked:border-blue-500 peer-checked:hover:border-blue-600 peer-checked:hover:bg-blue-600 transition text-white'>
																								<FaCheck className='scale-[95%]' />
																							</span>
																						</label>
																					</div>
																					<div className='h-[70px] my-auto w-[2px] bg-[#E3E3E3]'></div>
																				</div>
																			</div>

																			{currentPopup?.type ===
																				'delete' &&
																				currentPopup?.userId ===
																					user.username && (
																					<div
																						className={`overflow-hidden transition-all duration-300 ease-in-out ${
																							currentPopup?.type ===
																							'delete'
																								? 'h-auto border-[1px]'
																								: 'h-[1px] border-[0px]'
																						}`}>
																						<div
																							className={`${
																								currentPopup?.type ===
																								'delete'
																									? 'bg-[#B74644]'
																									: 'bg-[#e9e9e9]'
																							} p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500`}>
																							Confirmar
																							Desativar
																						</div>

																						<div className='flex px-6 py-3 gap-10 my-2 transition-all duration-500'>
																							<div className='text-[14px] font-medium text-[#757575]'>
																								<p className='text-[14px] font-medium text-[#757575]'>
																									Essa
																									ação
																									irá
																									desativar
																									o
																									usuário{' '}
																									<strong>
																										{
																											user.nome
																										}
																									</strong>

																									.
																									Confirma?
																								</p>
																								<div className='flex gap-4 mt-4'>
																									<button
																										onClick={async () => {
																											await handleDelete(
																												user
																											); // Chama a função para desativar o usuário
																											setCurrentPopup(
																												null
																											); // Fecha o popup
																										}}
																										className='bg-[#B74644] text-white px-4 py-2 rounded-md hover:bg-[#A33E3C] transition-all'>
																										Confirmar
																									</button>
																									<button
																										onClick={() =>
																											setCurrentPopup(
																												null
																											)
																										} // Cancela a desativação
																										className='bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-all'>
																										Cancelar
																									</button>
																								</div>
																							</div>
																						</div>
																					</div>
																				)}
																		</div>
																	)
																)}

															{/* Paginação */}
															<div className='flex justify-center items-center gap-2 mt-6 flex-wrap'>
																<button
																	onClick={() =>
																		setPaginaAtual(
																			(
																				p
																			) =>
																				Math.max(
																					1,
																					p -
																						1
																				)
																		)
																	}
																	disabled={
																		paginaAtual ===
																		1
																	}
																	className={`px-3 py-1 rounded bg-gray-200 hover:bg-[#004A80] hover:text-white transition ${
																		paginaAtual ===
																		1
																			? 'opacity-50 cursor-not-allowed'
																			: ''
																	}`}>
																	Anterior
																</button>

																{Array.from(
																	{
																		length: totalPaginas,
																	},
																	(_, i) =>
																		i + 1
																).map(
																	(
																		pagina
																	) => (
																		<button
																			key={
																				pagina
																			}
																			onClick={() =>
																				setPaginaAtual(
																					pagina
																				)
																			}
																			className={`px-3 py-1 rounded border ${
																				paginaAtual ===
																				pagina
																					? 'bg-[#004A80] text-white'
																					: 'bg-white text-gray-700 hover:bg-[#004A80] hover:text-white'
																			}`}>
																			{
																				pagina
																			}
																		</button>
																	)
																)}

																<button
																	onClick={() =>
																		setPaginaAtual(
																			(
																				p
																			) =>
																				Math.min(
																					totalPaginas,
																					p +
																						1
																				)
																		)
																	}
																	disabled={
																		paginaAtual ===
																		totalPaginas
																	}
																	className={`px-3 py-1 rounded bg-gray-200 hover:bg-[#004A80] hover:text-white transition ${
																		paginaAtual ===
																		totalPaginas
																			? 'opacity-50 cursor-not-allowed'
																			: ''
																	}`}>
																	Próxima
																</button>
															</div>
														</div>
													)}
												</div>
											</>
										)}
									</div>
								) : (
									<div>
										<div className='w-full border-b-[1px] pb-[17px] border-[#E3E3E3] flex justify-between my-5 px-4 text-[#757575] font-semibold'>
											<p className='w-[300px] flex items-center gap-2'>
												<BsSortAlphaDown className='text-[#757575]' />
												<span className='block md:hidden'>
													Usuários
												</span>
												<span className='hidden md:block'>
													Nome
												</span>
											</p>

											{/* E-mail (esconde em mobile) */}
											<p className='w-[300px] text-center hidden md:block'>
												E-mail
											</p>

											{/* CPF (esconde em mobile) */}
											<p className='w-[300px] text-center hidden md:block'>
												CPF
											</p>

											{/* Ações */}
											<p className='w-[80px] text-center'>
												Ações
											</p>
										</div>
										{/* LISTA DE USUARIOS PARA APROVAÇÃO*/}
										{loading ? (
											<Loading />
										) : (
											<div>
												{/* Mobile Layout */}
												<div className='sm:hidden'>
													{limitedList
														.filter(
															(item) =>
																item.ativo ===
																false
														)
														.sort((a, b) =>
															a.nome.localeCompare(
																b.nome
															)
														)
														.map((user, index) => (
															<div
																key={
																	index +
																	'mobile'
																}
																className='w-full flex flex-col justify-between my-[16px] px-4 text-[#757575] font-normal border-b-[1px] border-[#E3E3E3] pb-4'>
																<div className='flex flex-row justify-between items-center mt-4'>
																	<div>
																		<p
																			className>
																			<strong>
																				Nome:
																			</strong>{' '}
																			{
																				user.nome
																			}
																		</p>
																		<p className='text-sm text-gray-500'>
																			<strong>
																				Email:
																			</strong>{' '}
																			{
																				user.email
																			}
																		</p>
																		<p className='text-sm text-gray-500'>
																			<strong>
																				CPF:
																			</strong>{' '}
																			{
																				user.username
																			}
																		</p>
																	</div>
																	<div className='flex flex-col gap-2 justify-center items-center'>
																		<button
																			onClick={() =>
																				handleApproveWithConfirmation(
																					user.username
																				)
																			}
																			className='w-[80px] h-[30px] text-white bg-[#004A80] hover:bg-[#004A80] rounded-md text-sm'>
																			Aprovar
																		</button>

																		{/*  <button
                                      onClick={() =>
                                        handleRemoveWithConfirmation(
                                          user.username
                                        )
                                      }
                                      className="w-[80px] h-[30px] text-white bg-[#B74644] hover:bg-[#A33E3C] rounded-md text-sm"
                                    >
                                      Excluir
                                    </button> */}
																	</div>
																</div>
																{currentPopup?.type ===
																	'approve' &&
																	currentPopup?.userId ===
																		user.username && (
																		<div
																			className={`overflow-hidden transition-all duration-300 ease-in-out ${
																				currentPopup?.type ===
																				'approve'
																					? 'h-auto border-[1px]'
																					: 'h-[1px] border-[0px]'
																			}`}>
																			<div
																				className={`${
																					currentPopup?.type ===
																					'approve'
																						? 'bg-[#004A80]'
																						: 'bg-[#004A80]'
																				} p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500`}>
																				Confirmar
																				Aprovação
																			</div>
																			<div className='flex px-6 py-3 gap-10 my-4 transition-all duration-500'>
																				<div className='text-[14px] font-medium text-[#757575]'>
																					<p>
																						Você
																						está
																						prestes
																						a
																						aprovar{' '}
																						<strong>
																							{
																								user.nome
																							}
																						</strong>

																						.
																						Deseja
																						continuar?
																					</p>
																					<div className='flex gap-4 mt-4'>
																						<button
																							onClick={() => {
																								handleAprove(
																									user
																								);
																								setCurrentPopup(
																									null
																								);
																							}}
																							className='bg-[#004A80] text-white px-4 py-2 rounded-md hover:bg-[#004A80] transition-all'>
																							Aprovar
																						</button>
																						<button
																							onClick={() =>
																								setCurrentPopup(
																									null
																								)
																							}
																							className='bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-all'>
																							Cancelar
																						</button>
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
																{currentPopup?.type ===
																	'delete' &&
																	currentPopup?.userId ===
																		user.username && (
																		<div
																			className={`overflow-hidden transition-all duration-300 ease-in-out ${
																				currentPopup?.type ===
																				'delete'
																					? 'h-auto border-[1px]'
																					: 'h-[1px] border-[0px]'
																			}`}>
																			<div
																				className={`${
																					currentPopup?.type ===
																					'delete'
																						? 'bg-[#B74644]'
																						: 'bg-[#e9e9e9]'
																				} p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500`}>
																				Confirmar
																				Exclusão
																			</div>

																			<div className='flex px-6 py-3 gap-10 my-2 transition-all duration-500'>
																				<div className='text-[14px] font-medium text-[#757575]'>
																					<p className='text-[14px] font-medium text-[#757575]'>
																						A
																						exclusão
																						de{' '}
																						<strong>
																							{
																								user.nome
																							}
																						</strong>{' '}
																						é
																						permanente.
																						Deseja
																						prosseguir?{' '}
																					</p>
																					<div className='flex gap-4 mt-4'>
																						{/* Botão para abrir/fechar o popup */}
																						<button
																							onClick={() =>
																								setCurrentPopup(
																									null
																								)
																							} // Fecha o popup
																							className='bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-all'>
																							Cancelar
																						</button>
																						{/* Botão para remover o usuário 
                                            <button
                                              onClick={async () => {
                                                await handleRemoveWithConfirmation(
                                                  user.username
                                                ); // Chama a função para remover o usuário
                                                setCurrentPopup(null); // Fecha o popup após a remoção
                                              }}
                                              className="bg-[#B74644] text-white px-4 py-2 rounded-md hover:bg-[#A33E3C] transition-all"
                                            >
                                              Confirmar
                                            </button>*/}
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
															</div>
														))}
												</div>

												{/* Desktop Layout */}
												<div className='hidden sm:block'>
													{limitedList
														.filter(
															(item) =>
																item.ativo ===
																false
														)
														.sort((a, b) =>
															a.nome.localeCompare(
																b.nome
															)
														) // Ordena em ordem alfabética pelo nome
														.map((user, index) => (
															<div
																key={
																	index +
																	'pina'
																}>
																<div className='w-full flex pt-0 border-[#E3E3E3] justify-between my-[16px] px-4 text-[#757575] font-normal'>
																	<p className='flex sm:w-[300px] w-[80px] '>
																		{' '}
																		{
																			user.nome
																		}
																	</p>
																	<p className='sm:w-[300px]  w-[100px] overflow-x-scroll sm:overflow-x-auto text-center'>
																		{
																			user.email
																		}
																	</p>
																	<p className='sm:w-[300px]  w-[50px] overflow-x-scroll sm:overflow-x-auto text-center'>
																		{
																			user.username
																		}
																	</p>

																	<div className='flex sm:flex-row flex-col gap-2 sm:w-[80px] justify-center items-center'>
																		<button
																			onClick={() =>
																				handleApproveWithConfirmation(
																					user.username
																				)
																			} // Abre o popup de confirmação
																			className='w-[25px] h-[25px] p-1 border-[1px] border-[#004A80] bg-[#32993E] text-[#FFFFFF] rounded-md transition-transform duration-200 flex items-center justify-center hover:scale-105'>
																			<FaCheck className='w-[16px] h-[16px]' />
																		</button>
																		{/* Botão para aprovar o usuário 
                                    <button
                                      onClick={() =>
                                        handleRemoveWithConfirmation(
                                          user.username
                                        )
                                      } // Abre o popup de confirmação
                                      className="w-[25px] h-[25px] p-1 border-[1px] border-[#B74644] bg-[#B74644] rounded-md transition-all duration-200 flex items-center justify-center"
                                    >
                                      <span className="text-white text-[16px] font-bold">
                                        X
                                      </span>
                                    </button>*/}
																	</div>
																</div>

																{/* POPUP DE CONFIRMAÇÃO DE EXCLUSÃO */}
																{currentPopup?.type ===
																	'delete' &&
																	currentPopup?.userId ===
																		user.username && (
																		<div
																			className={`overflow-hidden transition-all duration-300 ease-in-out ${
																				currentPopup?.type ===
																				'delete'
																					? 'h-auto border-[1px]'
																					: 'h-[1px] border-[0px]'
																			}`}>
																			<div
																				className={`${
																					currentPopup?.type ===
																					'delete'
																						? 'bg-[#B74644]'
																						: 'bg-[#e9e9e9]'
																				} p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500`}>
																				Confirmar
																				Exclusão
																			</div>

																			<div className='flex px-6 py-3 gap-10 my-2 transition-all duration-500'>
																				<div className='text-[14px] font-medium text-[#757575]'>
																					<p className='text-[14px] font-medium text-[#757575]'>
																						A
																						exclusão
																						de{' '}
																						<strong>
																							{
																								user.nome
																							}
																						</strong>{' '}
																						é
																						permanente.
																						Deseja
																						prosseguir?{' '}
																					</p>
																					<div className='flex gap-4 mt-4'>
																						{/* Botão para remover o usuário */}
																						<button
																							onClick={async () => {
																								await handleRemoveWithConfirmation(
																									user.username
																								); // Chama a função para remover o usuário
																								setCurrentPopup(
																									null
																								); // Fecha o popup após a remoção
																							}}
																							className='bg-[#B74644] text-white px-4 py-2 rounded-md hover:bg-[#A33E3C] transition-all'>
																							Confirmar
																						</button>

																						{/* Botão para abrir/fechar o popup */}
																						<button
																							onClick={() =>
																								setCurrentPopup(
																									null
																								)
																							} // Fecha o popup
																							className='bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-all'>
																							Cancelar
																						</button>
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
																{/* POPUP DE CONFIRMAÇÃO DE APROVAÇÃO */}
																{currentPopup?.type ===
																	'approve' &&
																	currentPopup?.userId ===
																		user.username && (
																		<div
																			className={`overflow-hidden transition-all duration-300 ease-in-out ${
																				currentPopup?.type ===
																				'approve'
																					? 'h-auto border-[1px]'
																					: 'h-[1px] border-[0px]'
																			}`}>
																			<div
																				className={`${
																					currentPopup?.type ===
																					'approve'
																						? 'bg-[#004A80]'
																						: 'bg-[#e9e9e9]'
																				} p-2 pl-5 text-[14px] text-white font-medium rounded-br-[666px] transition-all duration-500`}>
																				Confirmar
																				Aprovação
																			</div>
																			<div className='flex px-6 py-3 gap-10 my-4 transition-all duration-500'>
																				<div className='text-[14px] font-medium text-[#757575]'>
																					<p>
																						Você
																						está
																						prestes
																						a
																						aprovar{' '}
																						<strong>
																							{
																								user.nome
																							}

																							.
																						</strong>{' '}
																						Deseja
																						continuar?
																					</p>
																					<div className='flex gap-4 mt-4'>
																						<button
																							onClick={() => {
																								handleAprove(
																									user
																								); // Confirma a aprovação
																								setCurrentPopup(
																									null
																								); // Fecha o popup
																							}}
																							className='bg-[#004A80] text-white px-4 py-2 rounded-md hover:bg-[#13335A] transition-all'>
																							Aprovar
																						</button>
																						<button
																							onClick={() =>
																								setCurrentPopup(
																									null
																								)
																							} // Cancela a aprovação
																							className='bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-gray-400 transition-all'>
																							Cancelar
																						</button>
																					</div>
																				</div>
																			</div>
																		</div>
																	)}
															</div>
														))}
												</div>
											</div>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
			<Footer />
		</div>
	);
};

export default Permissionador;
